import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

import { FauxInput, Message } from '@zendeskgarden/react-textfields';

const ref = React.createRef();

const ReCaptcha = ({ onChange, validation }) => (
  <FauxInput
    bare={!validation}
    validation={validation ? 'error' : 'none'}
    style={{ minHeight: 78 }}
  >
    <ReCAPTCHA
      sitekey="6LfKH54UAAAAAKnxeIiQPx9MJDPM9_Z7RxmF-8s7"
      ref={ref}
      onChange={() => onChange(ref.current.getValue())}
    />
    {validation && <Message validation="error">{validation}</Message>}
  </FauxInput>
);

ReCaptcha.propTypes = {
  onChange: PropTypes.func.isRequired,
  validation: PropTypes.string,
};

export default ReCaptcha;
